module.exports = __webpack_public_path__ + "img/League_06.1e4324f6.png";